export const brandPrimary = getComputedStyle(document.body).getPropertyValue('--alida-primary') || '#677ab1';
export const brandDark = getComputedStyle(document.body).getPropertyValue('--alida-primary-dark') || '#3f4e75';
export const brandSecondary = getComputedStyle(document.body).getPropertyValue('--alida-secondary') || '#9aa6d2';
export const datasourcePrimary = getComputedStyle(document.body).getPropertyValue('--datasource-color') || '#2dd4bf';
export const datasourceDark = getComputedStyle(document.body).getPropertyValue('--datasource-color-dark') || '#0d9488';
export const modelPrimary = getComputedStyle(document.body).getPropertyValue('--model-color') || '#2dd4bf';
export const modelDark = getComputedStyle(document.body).getPropertyValue('--model-color-dark') || '#0d9488';
export const datasetPrimary = getComputedStyle(document.body).getPropertyValue('--dataset-color') || '#2dd4bf';
export const datasetDark = getComputedStyle(document.body).getPropertyValue('--dataset-color-dark') || '#0d9488';
export const batchPrimary = getComputedStyle(document.body).getPropertyValue('--batch-color') || '#64748b';
export const batchDark = getComputedStyle(document.body).getPropertyValue('--batch-color-dark') || '#3b4553';
export const sourcePrimary = getComputedStyle(document.body).getPropertyValue('--source-color') || '#77ce26';
export const sourceDark = getComputedStyle(document.body).getPropertyValue('--source-color-dark') || '#3c730c';
export const processorPrimary = getComputedStyle(document.body).getPropertyValue('--processor-color') || '#f59e0b';
export const processorDark = getComputedStyle(document.body).getPropertyValue('--processor-color-dark') || '#9c6609';
export const sinkPrimary = getComputedStyle(document.body).getPropertyValue('--sink-color') || '#ec4899';
export const sinkDark = getComputedStyle(document.body).getPropertyValue('--sink-color-dark') || '#a82768';
export const streamPrimary = getComputedStyle(document.body).getPropertyValue('--stream-color') || '#0fb29a';

export type ColorVariables = typeof colorVariables;

const colorVariables = {
  brandPrimary, brandDark, brandSecondary,
  datasourcePrimary, datasourceDark,
  modelPrimary, modelDark,
  datasetPrimary, datasetDark,
  batchDark, batchPrimary,
  sourceDark, sourcePrimary,
  processorDark, processorPrimary,
  sinkDark, sinkPrimary,
  streamPrimary
};
export default colorVariables;

export const defaultFileContent = `:root {
  --alida-primary: #677ab1;
  --alida-primary-rgb: 103,122,177;
  --alida-primary-dark: #3f4e75;
  --alida-secondary: #9aa6d2;
  --alida-secondary-rgb: 154,166,210;
  --datasource-color: #2dd4bf;
  --datasource-color-dark: #0d9488;
  --datasource-color-rgb: 45, 212, 191;
  --dataset-color: #28ad7d;
  --dataset-color-dark: #19694c;
  --dataset-color-rgb: 25, 105, 76;
  --model-color: #31aee4;
  --model-color-dark: #1c7196;
  --model-color-rgb: 49, 174, 228;
  --batch-color: #64748b;
  --batch-color-dark: #3b4553;
  --stream-color: #0fb29a;
  --source-color: #77ce26;
  --source-color-dark: #3c730c;
  --processor-color: #f59e0b;
  --processor-color-dark: #9c6609;
  --sink-color: #ec4899;
  --sink-color-dark: #a82768;
}`;